$ = require('jquery')
_ = require('underscore')
Kloggyr = require('./kloggyr')

trackyr = {}

((trackyr) ->
  'use strict'

  trackyr.DEBOUNCE_INTERVAL = 500

  trackyr.initialized = false

  trackyr._done = (callback_data, ctx) ->
    clearTimeout(trackyr.timeout)
    cb = callback_data.callback
    args = callback_data.arguments
    cb or= ->
    args or= ->
    cb.apply(ctx or null, args)

  trackyr._track = (evt, props, cb) ->
    kloggyr_complete = $.Deferred()
    props_for_trackyr = _.extend({}, props)
    trackyr.log.info(message: evt, event_name: evt, event_data: props_for_trackyr, deferred: kloggyr_complete)

    $.when(kloggyr_complete).done(trackyr._done)
    # Timeout and automatically resolve deferreds to ensure callbacks are called within a reasonable time
    trackyr.timeout = setTimeout((->
      if kloggyr_complete.state() is 'pending'
        kloggyr_complete.resolve(callback: cb, arguments: [])
    ), Kloggyr.logging_config.timeout)

  trackyr.track = (evt, props, cb) ->
    try
      trackyr._track(evt, props, cb)
    catch error
      if cb
        cb()
      throw error


  trackyr.init = (obj={}, options={}) ->
    delete obj.mixpanel # don't include the mixpanel_id in the logging context

    # Once the page loads, add trackyr handlers to DOM elements that have `data-event` attributes
    $(document).ready ->
      init_global_styles(options)
      init_data_event_handlers()

    trackyr.initialized = true
    trackyr.log = new Kloggyr('trackyr', obj) or {}

  trackyr.track_form = (event, $target) ->
    $target.off('click', trackyr.track_link)
    form_name = $target.parents('form:first')
    event_name = $target.data('event-name')
    props = $target.data('properties') or {}
    skip = $target.data('skip') or false

    if not skip
      for item in $('form input')
        if $(item).attr('type') == "password"
          continue
        prop_name = $(item).attr('name')
        prop_value = $(item).val()
        props[prop_name] = prop_value

      for item in $('form textarea')
        prop_name = $(item).attr('name')
        prop_value = $(item).val()
        props[prop_name] = prop_value

      for item in $('form select')
        selected_options = $(item).children(':selected')
        prop_name = $(item).attr('name')
        prop_value = ($(option).text() for option in selected_options)
        props[prop_name] = prop_value

    return trackyr.track(event_name, props, ->
      return true  # okay to fire the default action now
    )

  trackyr.track_link = (event, $target) ->
    $(this).off('click', trackyr.track_link)
    event_name = $target.data('event-name')
    properties = $target.data('properties') or {}
    trackyr.track(event_name, properties, ->
      return true  # okay to fire the default action now
    )

  trackyr.track_event = (event, $target, value) ->
    event_name = $target.data('event-name')
    properties = $target.data('properties') or {}
    original = $target.data("original-value") or ""

    properties['original'] = original
    properties['changed'] = value
    trackyr.track(event_name, properties)

  trackyr.track_click = (event, $target) ->
    trackyr.track_event(event, $target, null)

  trackyr.track_boolean_option = (event, $target) ->
    trackyr.track_event(event, $target, trackyr.get_boolean_value($(event.target)))

  trackyr.track_checkbox = (event, $target) ->
    trackyr.track_event(event, $target, if $target.is(":checked") then "True" else "False")

  trackyr.track_multi_check = (event, $target) ->
    trackyr.track_event(event, $target, trackyr.get_multi_check_value($target))

  trackyr.track_single_select = (event, $target) ->
    selected_option = $target.children(':selected')
    trackyr.track_event(event, $target, $(selected_option).text())

  trackyr.track_multi_select = (event, $target) ->
    items = ($(item).text() for item in $target.children(':selected'))
    trackyr.track_event(event, $target, items)

  trackyr.track_text = (event, $target) ->
    trackyr.track_event(event, $target, trackyr.get_text_value($target))

  trackyr.track_filter_box = _.debounce((event, $target)->
    event_data =
      filter_text: $target.val()
    _.extend(event_data, $target.data('properties'))
    event_name = $target.data('event-name')

    trackyr.track(event_name, event_data)
  ,trackyr.DEBOUNCE_INTERVAL)

  trackyr.track_filter_dropdown = (event, $target) ->
    event_data =
      filter_value: $target.val()
    _.extend(event_data, $target.data('properties'))
    event_name = $target.data('event-name')
    trackyr.track(event_name, event_data)

  trackyr.save_original_value = ($el, value) ->
    $el.data("original-value", value)

  trackyr.get_label = ($input) ->
    id = $input.attr("id")
    $.trim($("[for='" + id + "']").text())

  trackyr.get_text_value = (input) ->
    value = $(input).val()
    if value isnt null then value else ""

  trackyr.get_multi_check_value = ($input) ->
    value = {}
    value[trackyr.get_label($input)] = $input.is(":checked")
    return value

  trackyr.get_boolean_value = ($input) ->
    value = {}
    id = $input.closest("div.controls").find("input:checked").attr("id")
    return $.trim($("label[for='" + id + "']").text())

)(trackyr)

init_global_styles = (options) ->
  # create style element with CSS for trackyr
  style = document.createElement('style')

  if options?.nonce
    style.setAttribute('nonce', options.nonce)

  style.innerHTML = '
    .__trackyr_pixel__ {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: -999999; 
    }'

  document.head.appendChild(style)

init_data_event_handlers = () ->
  $('body').on('click', '[data-event]', (event) ->
    $target = $(event.currentTarget)
    if $target.length == 0
      return
    if $target.attr('data-event') == 'form-click'
      trackyr.track_form(event, $target)
    else if $target.attr('data-event') == 'link-click'
      trackyr.track_link(event, $target)
    else if $target.attr('data-event') == 'click'
      trackyr.track_click(event, $target)
    else if $target.attr('data-event') == 'boolean'
      trackyr.save_original_value($target, trackyr.get_boolean_value($target))
      trackyr.track_boolean_option(event, $target)
    else if $target.attr('data-event') == 'checkbox'
      trackyr.save_original_value($target, if $el.is(":checked") then "True" else "False")
      trackyr.track_checkbox(event, $target)
    else if $target.attr('data-event') == 'multi-check'
      trackyr.save_original_value($target, trackyr.get_multi_check_value($target))
      trackyr.track_multi_check(event, $target)
    else if $target.attr('data-event') == 'single-select'
      trackyr.save_original_value($target, $target.children(':checked').text())
      trackyr.track_single_select(event, $target)
    else if $target.attr('data-event') == 'multi-select'
      items = ($(item).text() for item in $($target).children(':selected'))
      trackyr.save_original_value($target, items)
      trackyr.track_multi_select(event, $target)
  )

  $('body').on('focusout', '[data-event]', (event) ->
    $target = $(event.currentTarget)
    if $target.length == 0
      return
    if $target.attr('data-event') == 'text'
      trackyr.save_original_value($target, trackyr.get_text_value($target))
      trackyr.track_text(event, $target)
  )

  $('body').on('keyup', '[data-event]', (event) ->
    $target = $(event.currentTarget)
    if $target.length == 0
      return
    if $target.attr('data-event') == 'filter-box'
      trackyr.track_filter_box(event, $target)
  )

  $('body').on('change', '[data-event]', (event) ->
    $target = $(event.currentTarget)
    if $target.length == 0
      return
    if $target.attr('data-event') == 'filter-dropdown'
      trackyr.track_filter_dropdown(event, $target)
  )

module.exports = trackyr
